// CMD action 对应的独立业务处理器；新增透传类型时只需在此注册策略。
const cmdMessageStrategies = {
  // 企微群有新消息，按工单 ID 更新工单列表提醒。
  40019(message, store) {
    store.commit('workOrder/MARK_WE_COM_NEW_MESSAGE', message.ext?.workOrderId)
  }
}

/**
 * 创建 CMD 统一处理函数。
 * @param {Object} dependencies 外部依赖，使用注入方式便于独立测试。
 * @param {Function} dependencies.getStore 延迟获取 Vuex 实例，避免模块循环依赖。
 * @param {Object} dependencies.eventBus 全局事件总线。
 * @returns {Function} CMD 消息处理函数。
 */
export const createCmdMessageHandler =
  ({ getStore, eventBus }) =>
  message => {
    const store = getStore()
    const strategy = cmdMessageStrategies[String(message?.action)]
    strategy?.(message, store)

    // 兼容原群聊消息已读状态透传。
    const { groupId, readStatus } = message?.ext || {}
    if (groupId) {
      store.commit('updateMessageReadStatus', {
        chatType: 'group',
        chatId: groupId,
        readStatus
      })
    }

    // 保留原有聊天模块处理及页面级事件订阅能力。
    store.commit('cmdMessage', message)
    eventBus.emit('cmdMessage', message)
  }

export default cmdMessageStrategies
